export default __webpack_public_path__ + "static/media/animation-arrow2.6f875992.gif";